var React = require('react');

function IconMinus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon -"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1","key":2},React.createElement("g",{"fillRule":"nonzero","transform":"translate(-153.000000, -379.000000)"},React.createElement("g",null,React.createElement("g",{"transform":"translate(153.000000, 188.000000)"},React.createElement("g",{"transform":"translate(0.000000, 132.000000)"},React.createElement("g",{"transform":"translate(0.000000, 59.000000)"},[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#142B6F","key":0}),React.createElement("path",{"stroke":"#FFF","strokeWidth":"2","d":"M7,12 L17,12","key":1})]))))))]);
}

IconMinus.defaultProps = {"width":"24","height":"24","version":"1.1","viewBox":"0 0 24 24"};

module.exports = IconMinus;

IconMinus.default = IconMinus;
